import _ from "lodash";
import { IPermissions } from "../features/Member/slice";
import { ISubscriptionInfo } from "../features/Payment/slice";
import { IUserProfile } from "../features/User/slice";
import { PermissionProps } from "../hoc/withViewerTemplate";

export const generateAuthToken = (email: string, token: string) => {
  const buffer = Buffer.from(`${email}:${token}`, "utf8");
  return `${buffer.toString("base64")}`;
};

export const createPermissions = (param: {
  userProfile?: IUserProfile;
  perm?: IPermissions;
  subscriptionInfo?: ISubscriptionInfo;
  planName?: string;
}) => {
  const { userProfile, perm, subscriptionInfo, planName } = param;
  return {
    uploadVodPerm:
      userProfile?.userType === "Master" ||
      (userProfile?.userType === "SubMaster" && perm?.cloudUploadManual) ||
      subscriptionInfo?.servicePlanID === 1,
    // mantis - 8882, admin의 다운 권한이 있는 경우에만 다운가능하도록 수정(Leehj)
    downloadCameraVodPerm:
      userProfile?.userType === "Master" ||
      (userProfile?.userType === "SubMaster" && perm?.myBlackVueFilePlay) ||
      subscriptionInfo?.servicePlanID === 1 ||
      planName === "Smart plan" ||
      planName === "Basic plan",
    downloadCloudVodPerm:
      userProfile?.userType === "Master" ||
      (userProfile?.userType === "SubMaster" && perm?.cloudFilePlay) ||
      subscriptionInfo?.servicePlanID === 1 ||
      planName === "Smart plan" ||
      planName === "Basic plan",
    deleteVodPerm:
      userProfile?.userType === "Master" ||
      (userProfile?.userType === "SubMaster" && perm?.fileDelete) ||
      subscriptionInfo?.servicePlanID === 1 ||
      planName === "Smart plan" ||
      planName === "Basic plan",
    moveToCloudVodPerm:
      _.includes(["Master"], userProfile?.userType) ||
      (userProfile?.userType === "SubMaster" && perm?.fileMove) ||
      subscriptionInfo?.servicePlanID === 1 ||
      planName === "Smart plan" ||
      planName === "Basic plan",
    cameraVodPerm:
      // mantis - 8882, admin camera탭 활성화되도록 수정(Leehj)
      _.includes(["Master", "SubMaster"], userProfile?.userType) ||
      (userProfile?.userType === "User" && perm?.myBlackVueFilePlay) ||
      subscriptionInfo?.servicePlanID === 1 ||
      planName === "Smart plan" ||
      planName === "Basic plan",
    cloudVodPerm:
      // mantis - 8882, admin camera탭 cloud탭 활성화되도록 수정(Leehj)
      _.includes(["Master", "SubMaster"], userProfile?.userType) ||
      (userProfile?.userType === "User" && perm?.cloudFilePlay) ||
      subscriptionInfo?.servicePlanID === 1 ||
      planName === "Smart plan" ||
      planName === "Basic plan",
    fotaCamPerm:
      _.includes(["Master"], userProfile?.userType) ||
      // mantis - 11828, admin 계정 FOTA 권한이 없는 경우 비활성화 되도록 수정 (Leehj)
      (_.includes(["SubMaster"], userProfile?.userType) &&
        perm?.firmwareUpdate) ||
      subscriptionInfo?.servicePlanID === 1 ||
      planName === "Smart plan" ||
      planName === "Basic plan",
    settingsCamPerm:
      // _.includes(["Master", "SubMaster"], userProfile?.userType) ||
      userProfile?.userType === "Master" ||
      (userProfile?.userType === "SubMaster" &&
        (perm?.privacy ||
          perm?.eventAutoUpload ||
          // mantis - 10244, admin 계정은 camera setting권한 없는 경우 비활성화 되도록 수정 (Leehj)
          // perm?.pushNotifications ||
          perm?.firmwareSettings)) ||
      subscriptionInfo?.servicePlanID === 1 ||
      planName === "Smart plan" ||
      planName === "Basic plan",
    renameCamPerm:
      _.includes(["Master"], userProfile?.userType) ||
      // mantis - 11828, admin 계정 Camera profile setting 권한이 없는 경우 비활성화 되도록 수정 (Leehj)
      (_.includes(["SubMaster"], userProfile?.userType) &&
        perm?.changeDashcamName) ||
      subscriptionInfo?.servicePlanID === 1 ||
      planName === "Smart plan" ||
      planName === "Basic plan",
    deleteCamPerm:
      _.includes(["Master"], userProfile?.userType) ||
      subscriptionInfo?.servicePlanID === 1 ||
      planName === "Smart plan" ||
      planName === "Basic plan",

    rebootCamPerm:
      _.includes(["Master"], userProfile?.userType) ||
      subscriptionInfo?.servicePlanID === 1 ||
      planName === "Smart plan" ||
      planName === "Basic plan",

    // Playback more Tab 권한 추가

    moreTabPerm:
      _.includes(["Master", "SubMaster"], userProfile?.userType) ||
      subscriptionInfo?.servicePlanID === 1 ||
      planName === "Smart plan" ||
      planName === "Basic plan",

    //

    gpsTrackingPerm:
      userProfile?.userType === "Master" ||
      (userProfile?.userType === "SubMaster" && perm?.gpsTracking) ||
      planName === "Smart plan",
    geofencePerm:
      userProfile?.userType === "Master" ||
      (userProfile?.userType === "SubMaster" && perm?.geoFence),
    reportPerm:
      userProfile?.userType === "Master" ||
      (userProfile?.userType === "SubMaster" && perm?.driveReports) ||
      subscriptionInfo?.servicePlanID === 1 ||
      planName === "Smart plan" ||
      planName === "Basic plan",
    liveviewPerm:
      userProfile?.userType === "Master" ||
      (userProfile?.userType === "SubMaster" && perm?.liveView !== -1) ||
      (userProfile?.userType === "User" && perm?.liveView !== -1) ||
      subscriptionInfo?.servicePlanID === 1 ||
      planName === "Smart plan" ||
      planName === "Basic plan",
    // 멀티 라이브뷰 권한
    multiLiveviewPerm:
      userProfile?.userType === "Master" ||
      (userProfile?.userType === "SubMaster" && perm?.liveView !== -1) ||
      (userProfile?.userType === "User" && perm?.liveView !== -1),
    privacyPerm:
      userProfile?.userType === "Master" ||
      (userProfile?.userType === "SubMaster" && perm?.privacy) ||
      subscriptionInfo?.servicePlanID === 1 ||
      planName === "Smart plan" ||
      planName === "Basic plan",
    pushNotificationsPerm:
      userProfile?.userType === "Master" ||
      (userProfile?.userType === "SubMaster" && perm?.pushNotifications) ||
      subscriptionInfo?.servicePlanID === 1 ||
      planName === "Smart plan" ||
      planName === "Basic plan",
    eventAutoUploadPerm:
      userProfile?.userType === "Master" ||
      (userProfile?.userType === "SubMaster" && perm?.eventAutoUpload) ||
      subscriptionInfo?.servicePlanID === 1 ||
      planName === "Smart plan" ||
      planName === "Basic plan",
    firmwareSettingPerm:
      userProfile?.userType === "Master" ||
      (userProfile?.userType === "SubMaster" && perm?.firmwareSettings) ||
      subscriptionInfo?.servicePlanID === 1 ||
      planName === "Smart plan" ||
      planName === "Basic plan",
    downloadCSVReportPerm:
      userProfile?.userType === "Master" ||
      (userProfile?.userType === "SubMaster" && perm?.driveReports),
    shareToEventmapPerm:
      userProfile?.userType === "Master" ||
      (userProfile?.userType === "SubMaster" && perm?.sharingVideoToEventMap) ||
      subscriptionInfo?.servicePlanID === 1 ||
      planName === "Smart plan" ||
      planName === "Basic plan",
  } as PermissionProps;
};
